import { Button, TableItem, TableMessage } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { useNewWindowNavigate } from 'hooks/useNewWindowNavigate';
import { t } from 'i18next';
import { PiNavigationArrow, PiPlus, PiTrash } from 'react-icons/pi';
import { useGetChannelLightList } from 'services/channel/light';
import { IClientAccountForm } from 'services/client-account/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const ClientAccountChannels = () => {
  const channelsLightList = useGetChannelLightList();

  const { values, setFieldValue, status, initialStatus } =
    useFormikContext<IClientAccountForm>();

  const navigateToNewWindow = useNewWindowNavigate();

  const channelOptions = (channels: string[]) =>
    channelsLightList.data
      ?.filter(channel => !channels.includes(channel.id))
      .map(channel => ({
        label: channel.name,
        value: channel.id,
      })) ?? [];

  const goToChannel = (id: string) => {
    navigateToNewWindow(`channel/${id}`);
  };

  return (
    <Table
      displayMode
      data={{
        nodes:
          values.channels?.map((channel, key) => ({
            id: key,
            value: channel.id,
            label: channel.name,
          })) ?? [],
      }}
      columns={[
        {
          label: t('input.label.channel'),
          renderCell: ({ label, value, id }) => (
            <TableItem>
              {status?.displayMode ? (
                <TableItem.Text text={label} />
              ) : (
                <FormInput.Select
                  name={`channels[${id}].id`}
                  label={t('input.label.channel')}
                  options={channelOptions(
                    values.channels?.map(channel => channel.id)
                  )}
                  onChange={option => {
                    setFieldValue(`channels[${id}].id`, option.value);
                    setFieldValue(`channels[${id}].name`, option.label);
                  }}
                  value={{ label: label ?? '-', value: value }}
                />
              )}
            </TableItem>
          ),
        },

        {
          label: '',
          renderCell: ({ value }) => (
            <TableItem justifyPosition='end'>
              {status?.displayMode ? (
                <Button isClear onlyIcon onClick={() => goToChannel(value)}>
                  <Button.Icon
                    icon={<PiNavigationArrow transform='scale(-1,1)' />}
                  />
                </Button>
              ) : (
                <Button
                  variant={BUTTON_VARIANT.remove}
                  isClear
                  onlyIcon
                  onClick={() =>
                    setFieldValue(
                      `channels`,
                      values.channels?.filter(channel => channel.id !== value)
                    )
                  }>
                  <Button.Icon icon={<PiTrash />} />
                </Button>
              )}
            </TableItem>
          ),
        },
      ]}
      tableOptions={
        status?.displayMode
          ? undefined
          : {
              renderAfterTable: () => (
                <tfoot className='full-width-footer'>
                  <TableMessage
                    className='cursor-pointer'
                    disable={
                      values.channels?.length
                        ? !values.channels[values.channels.length - 1]?.id
                            .length
                        : false
                    }
                    onClick={() =>
                      setFieldValue(
                        `channels[${values.channels?.length ?? 0}]`,
                        {
                          id: '',
                          name: '',
                        }
                      )
                    }>
                    <TableItem.Text text={t('button.add')} />
                    <PiPlus />
                  </TableMessage>
                </tfoot>
              ),
            }
      }
      size='compact'
    />
  );
};

export default ClientAccountChannels;
